module.exports = __webpack_public_path__ + "static/img/foreground.809017c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/school-hall/foreground.svg
// module id = 177
// module chunks = 2